import React, { FC } from "react";
import ArrowMesh from "./ArrowMesh";
import { Sphere } from "@react-three/drei";
import * as THREE from "three";

import { getEulerAngles } from "../../utils/commonUtils";

export interface PlacementHelperMeshProps {
    name?: string;
    isCollapsed?: boolean;
    helperSize: number;
    location: THREE.Vector3;
    refDirection: THREE.Vector3;
    axis: THREE.Vector3;
    layers: THREE.Layers;
    onIsCollapsedChanged?: (isCollapsed: boolean) => void;
};

export const PlacementHelperMesh = (props: PlacementHelperMeshProps) => {
    const [isCollapsed, setIsCollapsed] = React.useState(props.isCollapsed ?? false);

    // Calculate the radius of the arrow body so ti is proportional to the size of the helper
    const arrowBodyRadius = props.helperSize/30;
    
    // Common properties for all arrows
    const commonProps = {
        position: new THREE.Vector3(0,0,0),
        arrowLength: props.helperSize,
        radius: arrowBodyRadius,
        layers: props.layers,
        userData: {name: "PlacementHelperMesh - Arrow"}
    };
    
    const sphereMaterial = new THREE.MeshStandardMaterial({ color: "orange" });
    
    // Calculate euler angles from X-axis to the reference direction
    const euler = getEulerAngles(new THREE.Vector3(1,0,0), props.refDirection, undefined);

    const toggleIsCollapsed = () => {
        setIsCollapsed(!isCollapsed);
        if (props.onIsCollapsedChanged) {
            props.onIsCollapsedChanged(!isCollapsed);
        }
    };

  return (
      <>
        <mesh layers={props.layers}
            name={props.name}
            position={new THREE.Vector3(props.location.x, props.location.y, props.location.z)} 
            rotation={euler.toArray()}
            userData={{name: "PlacementHelperMesh"}}
            onDoubleClick={() => toggleIsCollapsed()}>
            <Sphere     name="Sphere"
                        layers={props.layers} 
                        args={[props.helperSize/10, props.helperSize/10, props.helperSize/10]} 
                        material={sphereMaterial} 
                        userData={{name: "PlacementHelperMesh - Sphere"}}/>
            {
            !isCollapsed && 
            <>
                <ArrowMesh name="X-axis" {...commonProps} direction={new THREE.Vector3(1,0,0)} color="red" />
                <ArrowMesh name="Y-axis" {...commonProps} direction={new THREE.Vector3(0,1,0)} color="green" />
                <ArrowMesh name="Z-axis" {...commonProps} direction={new THREE.Vector3(0,0,1)} color="blue" /> 
            </>
            }
        </mesh>
      </>
  );
}


